import { createMutation } from "../../utils/queryFactories.js";
import { api } from "../../utils/fetch.js";
import { z } from "zod";

const GetResourceAgendaPublicLoginResponseSchema = z.object({
  message: z.string()
});

type GetResourceAgendaPublicLogin = z.infer<
  typeof GetResourceAgendaPublicLoginResponseSchema
>;

const GetResourceAgendaPublicLoginRequestSchema = z.object({
  slug: z.string(),
  password: z.string()
});

type GetResourceAgendaPublicLoginRequest = z.infer<
  typeof GetResourceAgendaPublicLoginRequestSchema
>;

export const usePostResourceAgendaPublicLogin = createMutation<
  GetResourceAgendaPublicLogin,
  GetResourceAgendaPublicLoginRequest,
  Error
>({
  mutationFn: async (variables) => {
    return api<
      GetResourceAgendaPublicLoginRequest,
      GetResourceAgendaPublicLogin
    >({
      method: "POST",
      url: `/public/:slug/login`,
      requestSchema: GetResourceAgendaPublicLoginRequestSchema,
      responseSchema: GetResourceAgendaPublicLoginResponseSchema,
      body: variables
    });
  }
});
